<template>
  <v-content>
    <v-toolbar color="secondary" dark>
      <v-toolbar-title :style="$store.state.textFormatting.headers"> Add User to {{$store.state.user.organisation}} </v-toolbar-title> <v-spacer></v-spacer> <v-icon>add</v-icon> 
    </v-toolbar>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-layout row wrap>
                    <v-flex md6 xs12>
                      <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.given_name"  :counter="32" label="Given Name" required></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.family_name" :counter="32" label="Family Name " required></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field :style="$store.state.textFormatting.main" v-model="form.username" :rules="usernameRule" :counter="32" label="Username" required></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field label="Password" v-model="form.password" :rules="passwordRules" 
                      :append-icon="e1 ? 'visibility' : 'visibility_off'" @click:append="(e1 = !e1)"
                        :type="e1 ? 'password' : 'text'" required :style="$store.state.textFormatting.main"></v-text-field>
                    </v-flex>
                    <v-flex md7 xs12>
                      <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.email" :counter="64" :rules="emailRules" label="Email Address" ></v-text-field>
                    </v-flex>
                    <v-flex md4 xs12>  
                      <v-layout justify-start>
                        <v-flex xs10>
                          <v-select :style="$store.state.textFormatting.main" v-model="form.attributes.name" :items="items" :rules="[v => !!v || 'Item is required']" label="User Type" required></v-select>
                        </v-flex>
                        <v-flex xs2>
                          <info>
                            <template slot>
                                {{headinfo}}
                            </template>
                            <template slot="body">
                                    {{bodyinfo}}
                            </template>
                          </info>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex md12 xs12 v-if="allowuser">
                      <v-text-field :style="$store.state.textFormatting.main" v-model="form.attributes.locale" label="Organisation" required></v-text-field>
                    </v-flex>
                    <v-card-actions>
                      <v-layout >

                          <v-flex xs12 class="px-4">
                              <v-btn :style="$store.state.textFormatting.main" color="red" @click="closeWindow" dark> Close </v-btn>
                          </v-flex>

                          <v-flex xs12 class="px-4">
                              <v-btn :style="$store.state.textFormatting.main" color="success" @click="addNewUser(form)" :disabled="!valid"> Submit </v-btn>
                          </v-flex>
                          
                      </v-layout>
                    </v-card-actions>
                  </v-layout>
                </v-container>
          </v-form>
      </v-card>
  </v-content>
</template>

<script>

import info from '../../shared/operational/infopopout.vue'
import { Auth } from 'aws-amplify';
import { components } from 'aws-amplify-vue';

    export default {
      name: 'adduser',
      components: {
        info,
        components
      },
    data: () => ({
      message: '',
      headinfo: 'User Type Info',
      bodyinfo: 'Allows users to access and alter different components. Admin: This user is allowed full access to all the components available. They are also able to remove/add/edit users and ASNs. Developer: Add/remove ASNs and edit current ASNs. Also able to view all components. Analyst: Able to view all components.',
      items: ['Admin', 'Developer', 'Analyst' ],
      emailRules: [ v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid' ],
      passwordRules: [ v => !!v || 'A valid password is required', v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/.test(v) || 'Password must be over 8 characters long and contain 1 uppercase, 1 lowercase, 1 special char (@$!%*?&_) and 1 number'],
      usernameRule: [v => !!v || 'Username is required', v => /^\S*$/.test(v) || 'Username must not contain spaces'],
      nameRules: [ v=> !!v || 'Name is required', v => /^[a-zA-Z]+$]/.test(v) || 'Name must be Valid' ],
      asns: [],
      selectUserType: '',
      e1: false,
      valid: true,
      select: null,
      firstname: "Nick",
      lastname: "Layton",
      formtest: {"username": 'username', "password": 'pasword_1', attributes: {
        "First-name": 'Nick', "Last-name": 'Layton ', "email": 'mail@name.com', "organisation": 'Org1'
      }
      },
      form: {"username": '', "password": '', "validationData": '', attributes: {
        "email": '', "given_name": "", "family_name": "", "locale": "", "name": ""
      },
      },
      allowuser: false
    }),
    beforeMount () {
      this.checkerTLA()
    },
  mounted () {
    this.asns = this.$store.state.userASNs.asn
  },
    methods: {
      closeWindow: function() {
        this.$emit('closeWindow')
      },
      checkerTLA: async function () {
        const username = await Auth.currentAuthenticatedUser();
        
        if (username.username == "TopLevelAdmin") {
          this.allowuser = true;
        } 
        console.log(this.allowuser)
      },
      addNewUser: async function () {
        this.$refs.form.validate();
        try {
      
          if (this.$refs.form.validate()) {
            const username = await Auth.currentAuthenticatedUser();
            const jwt = (await Auth.currentSession()).getAccessToken().getJwtToken()
             if (username.username != "TopLevelAdmin") {
               this.form.attributes.locale = username.attributes.locale
             }
             this.form.validationData=[{"Name":"token","Value":jwt}]
            const signup = await Auth.signUp(this.form);
            this.message = "Success, a user has been created (they wont appear in the list until confirmed by email)"
            this.$refs.form.reset()
            this.$emit('newUserAdded')
        }
      } catch(err){
        this.message = (err.message)
        console.log(err)
      }
    },
  }
    }
</script>